/**
 * Ticker Slider Infinity
 * Makes sure each of the two groups is at least as wide as the viewport,
 * so the -50% CSS loop never shows an empty gap (few blocks / wide screens).
 */
if (!customElements.get('ticker-slider-infinity')) {
  class TickerSliderInfinity extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ticker-slider-infinity__track');
      if (!this.track) return;

      this.groups = this.track.querySelectorAll('.ticker-slider-infinity__group');
      if (this.groups.length !== 2) return;

      this.template = Array.from(this.groups[0].children).map((item) => {
        const clone = item.cloneNode(true);
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        return clone;
      });

      this.fill = this.fill.bind(this);
      this.resizeObserver = new ResizeObserver(this.fill);
      this.resizeObserver.observe(this);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.fill);
      }
      this.fill();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    fill() {
      if (!this.template || !this.template.length) return;

      const viewportWidth = this.clientWidth;
      const groupWidth = this.groups[0].scrollWidth;
      if (!viewportWidth || !groupWidth || groupWidth >= viewportWidth) return;

      const setWidth = groupWidth / (this.groups[0].children.length / this.template.length);
      const setsNeeded = Math.ceil((viewportWidth - groupWidth) / setWidth);

      for (let i = 0; i < setsNeeded; i++) {
        this.groups.forEach((group) => {
          this.template.forEach((item) => group.appendChild(item.cloneNode(true)));
        });
      }
    }
  }

  customElements.define('ticker-slider-infinity', TickerSliderInfinity);
}
